import { createWithEqualityFn as create } from "zustand/traditional"

// Module-level store so the palette (mounted standalone) and its trigger
// (mounted inside AppNavigation, a separate React root) share open state.
export const useCommandPaletteStore = create(set => ({
  open: false,
  // How the palette was opened ("keyboard" | "trigger" | "shortcut"), read by
  // the "Opened" analytics event. Ignored on close.
  openSource: null,
  setOpen: (open, openSource = null) => set({ open, openSource })
}))
